<template>
    <div class="modal fade" id="updateStaticRegisterModal" role="dialog" aria-labelledby="updateStaticRegisterModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="updateStaticRegisterModalLabel">{{$t('buttons.edit.btnText')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <StaticRegisterEditCard v-model="model"
                                      v-if="showEditor"
                                      :create="false"
                                      @save="onSave"
                                      @cancel="onCancel">
                    </StaticRegisterEditCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { StaticRegistersForDropdown } from '@/models/models';
    import StaticRegisterEditCard from './StaticRegisterEditCard';

    export default {
        components: {
            StaticRegisterEditCard
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showEditor: false,
                model: new StaticRegistersForDropdown(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new StaticRegistersForDropdown();
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onSave(model) {
                this.$emit('onSave', model);
                this.onClose();
            },
            onCancel() {
                this.onClose();
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new StaticRegistersForDropdown(this.value);
                    this.showEditor = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
